export default __webpack_public_path__ + "ab2a262b1d29df3073c0e7bdcb38fd4c.png";